module.exports = __webpack_public_path__ + "dist/media/ec_comp_lists.3da451ca.svg";